<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <p>The sun broke through the cloud cover this morning. It has been so long since we felt real warmth on our skin that immediately, or so it seemed, limbs were bared and heads unfurled from hoods and scarves. Winter, it transpired, was not the unending season of grey and cold and chilled bones transported on seashaws cutting through ice after all. Our breath was not fated to frost forever. </p>
          <p>Oska took to the window as soon as he woke. He unlatched the wire and string tying it shut and eased opened the glass, letting new air into the apartment. A voicering sounded in the distance and lent a sensation of impending echo to the day ahead. </p>
          <p>It seems an age since the incident at the water funeral, when the city moved and the architecture changed. No-one has spoken of it, no songs have been exchanged, nothing has been sung or spoken. I walked by a closter last night, but no prayers were spoken about it either. It's as if the whole day never happened at all.</p>
          <p>Oska is still not happy walking through the city after what we saw, I only go out now when he is asleep. I go out to record.</p>
          <p>I thought of the tales of winters past, with frozen harbours and mortality amongst the elderly, those these stories can only be trusted as far as they can be personally related. So too the stories told of the ground opening up beneath homes and markets thirty years before. That the ground is unstable is known, easily confirmed by attending to the rebuilding process within the city, but entire streets opening up and swallowing buildings? </p>
          <p>That's the stuff listeners are ridiculed for. </p>
          <p>But now it is not the disappearing buildings, but the apperance of the new that fills conversations. There is a tension in the air, there are more closters than ever.</p>
          <p></p>
          <p>I stood by the wharf and imagined the buildings below the waterline. I tried to remember the drawings I made the year the waters receded. The rooftops shattered by the tide and gaping holes where attics and eaves once stood. Those remaindered lives, now abandoned. </p>
          <p>I remember moments that summer, tiny fragments of recollection working their way in between the earth of the past. My attention is like a knife, working them free and cleaning them down. </p>
          <p>Just one moment.</p>
          <p>The walk up to here brings you out over the city. Brings you up and able to glimpse the start of the Zone below, stretched and rambling outward.</p>
          <p>I remember laughter. I remember so well the smell of salt as a flock of gulls took to the air and scattered the sunlight. Early morning, a light hitting my face and warming my cheek, the smell of bread and the taste of coffee. Birds calling to one another as they climb above the city. </p>
          <p>Then quiet. </p>
          <p>These moments are gone now.</p>
          <p>The city seems to fluctuate, as whatever this is, takes hold of the place in which I live. </p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '4',

  data () {
    return {
      title: 'I Stood By The Wharf'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
